import { attempt, camelCase, get, isArray, isPlainObject, mapKeys, mapValues, set, unset } from 'lodash';

export const camelCaseKeys = (data) => {
    if (isPlainObject(data)) {
        const result = mapKeys(data, (v, k) => camelCase(k));
        return mapValues(result, v => camelCaseKeys(v));
    } else if (isArray(data)) {
        return data.map(v => camelCaseKeys(v));
    } else {
        return data;
    }
};

export const parseJSON = (str) => {
    return attempt(() => JSON.parse(str));
};

export const saveLocally = (key, path, value = null) => {
    let newValue = parseJSON(get(window.localStorage, key)) || {};
    if (path && value === null) {
        unset(newValue, path);
    } else if (path) {
        set(newValue, path, value);
    } else {
        newValue = value;
    }
    window.localStorage.setItem(key, stringifyJSON(value));
    return parseJSON(get(window.localStorage, key)) || null;
};

export const stringifyJSON = (data) => {
    return attempt(() => JSON.stringify(data));
};



// WEBPACK FOOTER //
// ./src/common/utils/json-utils.js